import { useCallback, useEffect, useState } from "react"
import ApiService from "../../../services/apiService"
import { method } from "lodash"
import Table from "../../table/Table"
import LeftIcon from "../../svg/LeftButton"
import RightIcon from "../../svg/RightIcon"

type wua = {
     Id:string|number|undefined
}

const GetSubChak = ({Id}:wua) =>{
     
     const[subChak,setSubChak] = useState()
     const [pageNumber, setPageNumber] = useState(1);
     const [pageSize, setPageSize] = useState(10);
     const [totalCount, setTotalCount] = useState(0);
      
     const getSubChak = async () =>{
          
        try{
              const response = await ApiService.axiosApi(`/chaklevelsummary/subchak`,{
                 method:'GET',
                 params:{
                     WuaId:Id,
                     pageNumber: pageNumber,
                     pageSize: pageSize,
                 }
              })

              if(response.success){
                  setSubChak(response.data.data)
                  setTotalCount(response.data.totalCount)
                  
              }else{
                 console.log('unable to get subchak')
              }
        }catch(e){
             console.log(e)
        }

     }

     useEffect(()=>{
          if(Id){
             getSubChak()
          }
     },[Id,pageNumber, pageSize])

     const totalPages = Math.ceil(totalCount / pageSize);

     const handleNext = useCallback(() => {
       setPageNumber((prev) => Math.min(totalPages, prev + 1));
     }, [setPageNumber, totalPages]);
   
     const handlePrev = useCallback(() => {
       setPageNumber((prev) => Math.max(1, prev - 1));
     }, [setPageNumber, totalPages]);



    return(
         <>
          { subChak != null ?   <Table
                        isAction={false}
                        data={subChak}
                        columns={[
                            {header:'Sub-Chak',accessor:'chakName'},
                            {header: ' Area(HA)', accessor: 'chakArea' },
                            {header:'Number Of Beneficiaries',accessor:'noOfBeneficiary'},
                        ]}

                        buttons={[   
                        ]}
                    />
                  : ''  }

<div
            className=" d-flex justify-content-end align-content-center"
            style={{ marginRight: "10px", marginTop: "10px" }}
          >
            <p style={{ marginRight: "10px", marginTop: "8px" }}>
              Page {pageNumber} of {totalPages}
            </p>
            <button
              onClick={handlePrev}
              disabled={pageNumber === 1}
              className={`icon-button ${
                pageNumber === totalPages ? "disabled" : ""
              }`}
            >
              <LeftIcon className="icon" />
            </button>
            <button
              className={`icon-button ${
                pageNumber === totalPages ? "disabled" : ""
              }`}
              onClick={handleNext}
              disabled={pageNumber === totalPages}
            >
              <RightIcon className="icon" />
            </button>
          </div>
            
         </>
    )
}
export default GetSubChak